<div class="professionals-container">
  <div class="professionals-content">

    <!-- ══════════════ LIST VIEW ══════════════ -->
    <ng-container *ngIf="!selectedDetailUid">
     <!-- Profile completion filter chip (shown when arriving from dashboard) -->
      <div class="active-filter-chip" *ngIf="activeProfileFilter">
        <i class="bi bi-funnel-fill"></i>
        Profile Completion: <strong>{{ profileFilterLabel }}</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="activeProfileFilter=''; profileFilterLabel=''; dateRange=''; applyFilter()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Onboarding filter chip (shown when arriving from dashboard chart click) -->
      <div class="active-filter-chip" *ngIf="onboardingIds.length > 0">
        <i class="bi bi-graph-up-arrow"></i>
        Onboarding Trend: <strong>{{ onboardingFilter | titlecase }} — {{ onboardingPoint }}</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="onboardingIds=[]; onboardingFilter=''; onboardingPoint=''; dateRange=''; applyFilter()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Login filter chip (shown when arriving from dashboard "Total Logged-in" card click) -->
      <div class="active-filter-chip" *ngIf="loginIds.length > 0">
        <i class="bi bi-person-check-fill"></i>
        Logged-in Users: <strong>Last 24h</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="loginIds=[]; dateRange=''; applyFilter()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Mobile download filter chip (shown when arriving from dashboard mobile-app card click) -->
      <div class="active-filter-chip active-filter-chip--teal" *ngIf="mobileUserIds.length > 0">
        <i class="bi bi-phone-fill"></i>
        Mobile App Downloads:
        <strong>{{ mobilePlatform === 'android' ? 'Android' : mobilePlatform === 'ios' ? 'iOS' : 'All Platforms' }}</strong>
        <span *ngIf="mobileBarLabel" class="chip-bar-label">— {{ mobileBarLabel }}</span>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="mobileUserIds=[]; mobilePlatform=''; mobileBarLabel=''; dateRange=''; applyFilter()">
          <i class="bi bi-x"></i>
        </button>
      </div>
         <!-- Engagement filter chip (shown when arriving from dashboard Engagement Trend chart click) -->
      <div class="active-filter-chip" *ngIf="engagementIds.length > 0">
        <i class="bi bi-activity"></i>
        Engagement Trend:
        <strong>{{ engagementPoint }}<span *ngIf="engagementSegment"> — {{ engagementSegment }}</span></strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="engagementIds=[]; engagementFilter=''; engagementPoint=''; engagementSegment=''; dateRange=''; applyFilter()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Location city filter chip (from dashboard location card row click) -->
      <div class="active-filter-chip" *ngIf="locationCity">
        <i class="bi bi-geo-alt-fill"></i>
        Location: <strong>{{ locationCity }}</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="locationCity=''; dateRange=''; loadProfessionals()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Practice area filter chip (from dashboard practice card row click) -->
      <div class="active-filter-chip" *ngIf="practiceAreaFilter">
        <i class="bi bi-briefcase-fill"></i>
        Practice Area: <strong>{{ practiceAreaFilter }}</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="practiceAreaFilter=''; dateRange=''; loadProfessionals()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Service filter chip (from dashboard services tab row click) -->
      <div class="active-filter-chip" *ngIf="serviceFilter">
        <i class="bi bi-tools"></i>
        Service: <strong>{{ serviceFilter }}</strong>
        <span class="chip-date-range" *ngIf="dateRange">
          <i class="bi bi-calendar3"></i> {{ dateRange }}
        </span>
        <button class="chip-clear" (click)="serviceFilter=''; dateRange=''; loadProfessionals()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <!-- Header -->
      <div class="list-header">
        <h5>List Of Lawyers <span *ngIf="!isLoading && dataSource.length > 0" class="leads-count-badge">{{ dataSource.length }}</span></h5>
        <div class="list-actions">
          <!-- Search Box -->
          <div class="search-box">
            <div class="input-group">
              <span class="input-group-text bg-transparent" style="border:0px !important">
                <i class="bi bi-search"></i>
              </span>
              <input type="text" class="form-control"
                    style="padding:0px !important;border:0px !important"
                    placeholder="Search by name, email, contact..."
                    [(ngModel)]="searchQuery"
                    (input)="onSearch()"
                    autocomplete="new-password"
                    (keyup.enter)="onSearch()">
              <span class="input-group-text bg-transparent clear-btn-wrap"
                    *ngIf="searchQuery"
                    (click)="clearSearch()"
                    style="cursor:pointer;">
                <i class="bi bi-x-circle"></i>
              </span>
            </div>
          </div>

          <!-- Category Filter -->
          <div class="category-filter-group">
            <button class="cat-filter-btn" [class.cat-filter-btn--active]="categoryFilter === ''"
                    (click)="selectCategoryFilter('')">All</button>
            <button class="cat-filter-btn" [class.cat-filter-btn--active]="categoryFilter === 'solo'"
                    (click)="selectCategoryFilter('solo')">Solo</button>
            <button class="cat-filter-btn" [class.cat-filter-btn--active]="categoryFilter === 'firm'"
                    (click)="selectCategoryFilter('firm')">Firm</button>
          </div>

          <!-- Add Button -->
          <button class="btn btn-primary add-btn" (click)="openAddModal()" *ngIf="role !== 'Onboarding'">
            <i class="bi bi-plus"></i> Add Lawyer
          </button>
        </div>
      </div>

      <!-- Sub Tabs -->
    <div class="account-type-tabs">
    
      <!-- SU Only -->
      <button *ngIf="role === 'SuperUser'" class="account-tab" [class.active]="accountTypeFilter === 'all'"
        (click)="selectAccountType('all')">
        All
      </button>
    
      <!-- SU + Support + Other Roles -->
      <button class="account-tab" [class.active]="accountTypeFilter === 'client'" (click)="selectAccountType('client')">
        Clients
      </button>
    
      <!-- SU + Support -->
      <button *ngIf="role === 'SuperUser' || role === 'Support'" class="account-tab"
        [class.active]="accountTypeFilter === 'demo'" (click)="selectAccountType('demo')">
        Demo
      </button>
    
      <!-- SU + Support -->
      <button *ngIf="role === 'SuperUser' || role === 'Support'" class="account-tab"
        [class.active]="accountTypeFilter === 'test'" (click)="selectAccountType('test')">
        Test Account
      </button>
    
    </div>

      <!-- Table -->
      <div class="professionals-table" [class.loading]="isLoading"
           *ngIf="dataSource.length > 0; else noData">
        <table class="table">
          <thead>
            <tr>
              <th class="thdata sortable-col" scope="col" (click)="sortBy('name')">
                {{ categoryFilter === 'solo' ? 'Name' : 'Name / Firm Name' }}
                <i class="bi sort-icon" [ngClass]="getSortIcon('name')"></i>
              </th>
              <th class="thdata sortable-col hide-md" scope="col" (click)="sortBy('email')">
                Email <i class="bi sort-icon" [ngClass]="getSortIcon('email')"></i>
              </th>
              <th class="thdata hide-md" scope="col">Phone Number</th>
              <th class="thdata" scope="col">Location</th> 
              <th class="thdata sortable-col" scope="col" (click)="sortBy('account_activation_date')">
                Account Activation Date <i class="bi sort-icon" [ngClass]="getSortIcon('account_activation_date')"></i>
              </th>
              <th class="thdata" scope="col">Registered Platform</th>
              <th class="thdata sortable-col" scope="col" (click)="sortBy('last_login')">
                Last Login <i class="bi sort-icon" [ngClass]="getSortIcon('last_login')"></i>
              </th>
              <th class="thdata" scope="col">Profile Completion</th>   
              <th class="thdata" scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let professional of getPage()">
              <tr>
                <td>
                  <div class="lawyer-name-cell">
                    <div class="lawyer-name">
                      <a class="lawyer-name-link"
                         href="javascript:void(0)"
                         title="View lawyer history"
                         (click)="openLawyerHistory(professional)">
                        {{ professional.name || '-' }}
                      </a>
                    </div>
                
                    <span *ngIf="professional.account_type" class="account-type-badge" [ngClass]="{
                        'badge-client': professional.account_type === 'client',
                        'badge-demo': professional.account_type === 'demo',
                        'badge-test': professional.account_type === 'internal_test'
                      }">
                      {{
                      professional.account_type === 'internal_test'
                      ? 'Test Account'
                      : (professional.account_type | titlecase)
                      }}
                    </span>
                  </div>
                </td>
                <td class="hide-md email-cell">
                  <a *ngIf="professional.email" [href]="'mailto:' + professional.email" class="email-link">
                    {{ professional.email }}
                  </a>
                  <span *ngIf="!professional.email">-</span>
                </td>
                <td class="hide-md">{{ professional.phone || '-' }}</td>
                <td class="hide-md">{{ professional.location || '-' }}</td>
                <td>{{ formatDate(professional.account_activation_date) }}</td>
                <td>{{ professional.reg_platform || '-' }}</td>
                <td>{{ formatDate(professional.last_login) }}</td>
                <td>
                  <span class="profile-completion-wrap">
                    <span class="profile-bar-bg">
                      <span class="profile-bar-fill"
                            [style.width.%]="getProfileCompletion(professional)"></span>
                    </span>
                    {{ getProfileCompletion(professional) }}%
                  </span>
                </td>

                <!-- Three-dot Actions -->
                <td>
                  <div class="action-menu-wrap" (click)="$event.stopPropagation()">
                    <button class="action-btn three-dot-btn"
                            (click)="toggleActionMenu(professional.uid, $event)"
                            title="Actions">
                      <i class="bi bi-three-dots-vertical"></i>
                    </button>

                    <div class="action-dropdown" *ngIf="activeMenuUid === professional.uid">
                      <button class="action-dd-item view-item"
                              (click)="openLawyerHistory(professional); activeMenuUid = null">
                        <i class="bi bi-clock-history"></i> View History
                      </button>
                      <div class="action-dd-divider" *ngIf="role !== 'Onboarding'"></div>
                      <button class="action-dd-item upgrade-item" *ngIf="role !== 'Onboarding'"
                              (click)="openPlanModal(professional, 'upgrade')">
                        <i class="bi bi-arrow-up-circle"></i> Upgrade
                      </button>
                      <button class="action-dd-item downgrade-item" *ngIf="!['Sales', 'Onboarding'].includes(role)"
                              (click)="openPlanModal(professional, 'downgrade')">
                        <i class="bi bi-arrow-down-circle"></i> Downgrade
                      </button>
                      <button class="action-dd-item account-type-item upgrade-item" *ngIf="!['Sales', 'Onboarding'].includes(role)"
                        (click)="openAccountTypeModal(professional); activeMenuUid = null">
                        <i class="bi bi-person-circle"></i>
                        Account Type
                      </button>
                      <div class="action-dd-divider" *ngIf="role !== 'Onboarding'"></div>
                      <button class="action-dd-item delete-item" *ngIf="role !== 'Onboarding'"
                              (click)="openDeleteModal(professional); activeMenuUid = null">
                        <i class="bi bi-trash"></i> Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Skeleton -->
      <div *ngIf="isLoading" class="skeleton-wrapper">
        <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]">
          <div class="skeleton-cell short"></div>
          <div class="skeleton-cell wide"></div>
          <div class="skeleton-cell wide hide-md"></div>
          <div class="skeleton-cell medium hide-md"></div>
          <div class="skeleton-cell medium"></div>
          <div class="skeleton-cell medium"></div>
          <div class="skeleton-cell medium"></div>
          <div class="skeleton-cell medium"></div>
          <div class="skeleton-cell short"></div>
          <div class="skeleton-cell short"></div>
        </div>
      </div>

      <!-- No Data -->
      <ng-template #noData>
        <div *ngIf="!isLoading" class="text-center noprofessionals">
          <i class="bi bi-person-slash no-data-icon"></i>
          <p>No Lawyers Found!</p>
        </div>
      </ng-template>

      <!-- Pagination -->
      <div class="pagination-area" *ngIf="dataSource.length > 0">
        <div class="pagination-info">{{ getPaginationRange() }}</div>
        <nav aria-label="Professionals pagination">
          <ul class="pagination mb-0">
            <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
              <a class="page-link" href="javascript:void(0)" (click)="goToFirstPage()">
                <i class="bi bi-chevron-double-left biarr"></i>
              </a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': pageIndex === 0}">
              <a class="page-link" href="javascript:void(0)" (click)="goToPrevPage()">
                <i class="bi bi-chevron-left biarr"></i> Previous
              </a>
            </li>
            <li *ngFor="let page of getPageNumbers()" class="page-item"
                [ngClass]="{'active': page === pageIndex + 1}">
              <a class="page-link" href="javascript:void(0)" (click)="goToPage(page - 1)">{{ page }}</a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
              <a class="page-link" href="javascript:void(0)" (click)="goToNextPage()">
                Next <i class="bi bi-chevron-right biarr"></i>
              </a>
            </li>
            <li class="page-item" [ngClass]="{'disabled': pageIndex >= getTotalPages() - 1}">
              <a class="page-link" href="javascript:void(0)" (click)="goToLastPage()">
                <i class="bi bi-chevron-double-right biarr"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </ng-container>
    <!-- ══════════════ END LIST VIEW ══════════════ -->


    <!-- ══════════════ DETAIL VIEW ══════════════ -->
    <ng-container *ngIf="selectedDetailUid">

      <!-- Detail Header (always visible) -->
      <div class="detail-page-header">
        <button class="btn-back" (click)="closeDetailPanel()">
          <i class="bi bi-arrow-left"></i> Back to List
        </button>
        <div class="detail-header-identity">
          <h5>Lawyer Details</h5>
          <ng-container *ngIf="!isDetailLoading && detailData">
            <span class="detail-header-divider">—</span>
            <!-- Avatar: photo or initials -->
            <img *ngIf="detailData.profile_pic"
                 [src]="detailData.profile_pic"
                 class="detail-header-pic"
                 [alt]="detailData.name">
            <div class="detail-header-avatar" *ngIf="!detailData.profile_pic">
              {{ getInitials(detailData.name) }}
            </div>
            <span class="detail-header-name">{{ detailData.name || '-' }}</span>
            <span class="detail-cat-badge ms-1"
                  [ngClass]="(detailData.category?.toLowerCase() || '').includes('firm') ? 'cat-firm' : 'cat-solo'">
              {{ detailData.category | titlecase }}
            </span>
          </ng-container>
        </div>
      </div>

      <!-- ── Loading skeleton ── -->
      <ng-container *ngIf="isDetailLoading">
        <div class="detail-fields-grid">
          <div class="detail-section" *ngFor="let _ of [1,2,3,4]">
            <div class="detail-section-title">&nbsp;</div>
            <div class="detail-fields-list">
              <div class="detail-field-row" *ngFor="let __ of [1,2,3]">
                <div class="detail-skel-line" style="width:90px"></div>
                <div class="detail-skel-line" style="width:110px"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ── Loaded content ── -->
      <ng-container *ngIf="!isDetailLoading && detailData">

        <!-- Detail Fields Grid -->
        <div class="detail-fields-grid">

          <!-- Contact Information -->
          <div class="detail-section">
            <p class="detail-section-title">Contact Information</p>
            <div class="detail-fields-list">
              <div class="detail-field-row">
                <span class="detail-label">Email</span>
                <span class="detail-value">
                  <a *ngIf="detailData.email" [href]="'mailto:' + detailData.email" class="email-link">
                    {{ detailData.email }}
                  </a>
                  <span *ngIf="!detailData.email">-</span>
                </span>
              </div>
              <div class="detail-field-row">
                <span class="detail-label">Phone</span>
                <span class="detail-value">{{ detailData.contact_phone || '-' }}</span>
              </div>
              <div class="detail-field-row">
                <span class="detail-label">Registered Location</span>
                <span class="detail-value">{{ detailData.reg_location || '-' }}</span>
              </div>
              <div class="detail-field-row"
                   *ngIf="(detailData.category.toLowerCase() || '').includes('firm')">
                <span class="detail-label">Contact Person</span>
                <span class="detail-value">{{ detailData.contact_person || '-' }}</span>
              </div>
            </div>
          </div>

          <!-- Account Information -->
          <div class="detail-section">
            <p class="detail-section-title">Account Information</p>
            <div class="detail-fields-list">
              <div class="detail-field-row">
                <span class="detail-label">T&amp;C Signed On</span>
                <span class="detail-value">
                  {{
                    detailData.terms?.accepted && detailData.terms?.accepted_at
                      ? formatDate(detailData.terms!.accepted_at)
                      : 'Not signed'
                  }}
                </span>
              </div>
              <div class="detail-field-row">
                <span class="detail-label">First Login</span>
                <span class="detail-value detail-value--muted">{{ formatDate(detailData.first_login) }}</span>
              </div>
              <div class="detail-field-row">
                <span class="detail-label">Last Login</span>
                <span class="detail-value">{{ formatDate(detailData.last_login) }}</span>
              </div>
            </div>
          </div>

          <!-- Subscription -->
          <div class="detail-section">
            <p class="detail-section-title">
              Subscription
              <span class="plan-name-badge" *ngIf="detailData.plan_name">{{ detailData.plan_name }}</span>
            </p>
            <div class="detail-fields-list">
              <div class="detail-field-row">
                <span class="detail-label">Start Date</span>
                <span class="detail-value">{{ formatDate(detailData.sub_start_date) }}</span>
              </div>
              <div class="detail-field-row">
                <span class="detail-label">End Date</span>
                <span class="detail-value">{{ formatDate(detailData.sub_end_date) }}</span>
              </div>
              <div class="detail-field-row" *ngIf="detailData.remaining_days !== null && detailData.remaining_days !== undefined">
                <span class="detail-label">Remaining Days</span>
                <span class="detail-value">
                  <span class="remaining-days-badge"
                        [class.remaining-days-badge--low]="(detailData.remaining_days ?? 0) <= 10"
                        [class.remaining-days-badge--mid]="(detailData.remaining_days ?? 0) > 10 && (detailData.remaining_days ?? 0) <= 30">
                    {{ detailData.remaining_days }} days
                  </span>
                </span>
              </div>
            </div>
          </div>

          <!-- Active Devices -->
          <div class="detail-section">
            <p class="detail-section-title">Active Devices</p>
            <div class="detail-fields-list">
              <ng-container *ngIf="detailData.devices_info && detailData.devices_info.length > 0; else noDevices">
                <div class="device-item" *ngFor="let device of detailData.devices_info">
                  <div class="device-icon-wrap"
                       [style.background]="getPlatformIconColor(device.platform) + '1a'"
                       [style.color]="getPlatformIconColor(device.platform)">
                    <i class="bi" [ngClass]="getPlatformIcon(device.platform)"></i>
                  </div>
                  <div class="device-info-text">
                    <span class="device-platform-name">{{ getPlatformLabel(device.platform) }}</span>
                    <span class="device-last-seen">Last active: {{ formatDate(device.last_login) }}</span>
                  </div>
                </div>
              </ng-container>
              <ng-template #noDevices>
                <div class="detail-field-row" style="justify-content:center;">
                  <span class="detail-value detail-value--muted">No active devices</span>
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Profile (full width, solo only) -->
          <div class="detail-section detail-section--full-width"
               *ngIf="!(detailData.category?.toLowerCase() || '').includes('firm')">
            <p class="detail-section-title">Profile</p>
            <div class="detail-fields-list">

              <!-- Completion + Missing count row -->
              <div class="detail-field-row profile-summary-row">
                <div class="profile-summary-left">
                  <span class="detail-label">Completion</span>
                  <span class="profile-completion-wrap">
                    <span class="profile-bar-bg profile-bar-bg--wide">
                      <span class="profile-bar-fill"
                            [style.width.%]="detailData.profile_completion_percentage"></span>
                    </span>
                    <strong class="profile-pct-value">{{ detailData.profile_completion_percentage }}%</strong>
                  </span>
                </div>
                <div class="profile-summary-center">
                  <span class="detail-label">Profile Picture</span>
                  <span class="profile-pic-status"
                        [class.profile-pic-status--yes]="detailData.profile_pic"
                        [class.profile-pic-status--no]="!detailData.profile_pic">
                    <i class="bi" [class.bi-check-circle-fill]="detailData.profile_pic"
                                  [class.bi-x-circle-fill]="!detailData.profile_pic"></i>
                    {{ detailData.profile_pic ? 'Yes' : 'No' }}
                  </span>
                </div>
                <div class="profile-summary-center">
                  <span class="detail-label">Set Availability</span>
                  <span class="availability-status-badge"
                        [class.availability-status-badge--updated]="detailData.set_availability === 'updated'"
                        [class.availability-status-badge--pending]="detailData.set_availability !== 'updated'">
                    <i class="bi"
                       [class.bi-check-circle-fill]="detailData.set_availability === 'updated'"
                       [class.bi-clock-fill]="detailData.set_availability !== 'updated'"></i>
                    {{ detailData.set_availability === 'updated' ? 'Updated' : 'Pending' }}
                  </span>
                </div>
                <div class="profile-summary-right">
                  <span class="detail-label">Fields - Not filled</span>
                  <span *ngIf="getMissingFieldsCount(detailData.missing_fields) === 0"
                        class="detail-value detail-value--success">
                    <i class="bi bi-check-circle-fill"></i> All complete
                  </span>
                  <span *ngIf="getMissingFieldsCount(detailData.missing_fields) > 0"
                        class="missing-count-badge">
                    <i class="bi bi-exclamation-circle-fill"></i>
                    {{ getMissingFieldsCount(detailData.missing_fields) }} fields pending
                  </span>
                </div>
              </div>

              <!-- FLAT missing fields (string[]) -->
              <div class="missing-fields-compact-row"
                   *ngIf="isFlatMissingFields(detailData.missing_fields) && detailData.missing_fields.length > 0">
                <span class="missing-field-chip"
                      *ngFor="let field of detailData.missing_fields">
                  {{ formatMissingFieldLabel(field) }}
                </span>
              </div>

              <!-- SECTIONED missing fields ({section, fields[]}[]) — availability section excluded (shown in summary row above) -->
              <div class="missing-sections-grid" *ngIf="isSectionedMissingFields(detailData.missing_fields)">
                <ng-container *ngFor="let group of detailData.missing_fields">
                  <div class="missing-section-group"
                       *ngIf="group.section.toLowerCase() !== 'availability'">
                    <div class="missing-section-header">
                      <i class="bi bi-tag-fill"></i>
                      {{ formatSectionLabel(group.section) }}
                      <span class="missing-section-count">{{ group.fields.length }} not filled</span>
                    </div>
                    <div class="missing-fields-compact-row missing-fields-compact-row--nosep">
                      <span class="missing-field-chip"
                            *ngFor="let field of group.fields">
                        {{ formatMissingFieldLabel(field) }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </div>

            </div>
          </div>

        </div><!-- /detail-fields-grid -->

      </ng-container><!-- /loaded -->

      <!-- Error state -->
      <ng-container *ngIf="!isDetailLoading && !detailData">
        <div class="noprofessionals text-center" style="margin-top:60px;">
          <i class="bi bi-exclamation-circle no-data-icon"></i>
          <p>Could not load details. Please try again.</p>
        </div>
      </ng-container>

    </ng-container>
    <!-- ══════════════ END DETAIL VIEW ══════════════ -->
<!-- ══════════════════════════════════════════════════════════
     ADD MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showAddModal" (click)="closeAddModal()"></div>
<div class="modal-panel" *ngIf="showAddModal">
  <div class="modal-header">
    <h6 class="modal-title">
      <i class="bi bi-person-plus me-2"></i>Add Lawyer
    </h6>
    <button class="modal-close-btn" (click)="closeAddModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <input type="text" style="display:none" autocomplete="username">
    <input type="password" style="display:none" autocomplete="new-password">
    <div class="form-grid">

      <!-- Category -->
      <div class="form-group full-width radio-group">
        <label class="form-label">Category <span class="req">*</span></label>
        <div class="radio-buttons-row">
          <label class="radio-option">
            <input type="radio" name="addCat" value="solo"
                   [checked]="addForm.category === 'solo'"
                   (change)="onAddCategoryChange('solo')">
            <span class="radio-label">Solo Lawyer</span>
          </label>
          <label class="radio-option">
            <input type="radio" name="addCat" value="entity"
                   [checked]="addForm.category === 'entity'"
                   (change)="onAddCategoryChange('entity')">
            <span class="radio-label">Law Firm</span>
          </label>
        </div>
      </div>

      <!-- ════ SOLO LAWYER fields ════ -->
      <ng-container *ngIf="addForm.category === 'solo'">

        <div class="form-group">
          <label class="form-label">Name <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Enter full name"
                [(ngModel)]="addForm.fullname"
                (ngModelChange)="clearAddError('fullname')"
                [class.is-invalid]="addErrors['fullname']"
                autocomplete="new-password"
                name="fullname_solo">
          <div class="field-error" *ngIf="addErrors['fullname']">{{ addErrors['fullname'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">Country <span class="req">*</span></label>
          <select class="form-select form-select--disabled" [(ngModel)]="addForm.country" disabled>
            <option value="India">India</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Email <span class="field-hint">(required if no phone)</span></label>
          <input type="email" class="form-control" placeholder="Email address"
                [(ngModel)]="addForm.email"
                (ngModelChange)="clearAddError('email')"
                [class.is-invalid]="addErrors['email']"
                autocomplete="new-password"
                name="email_solo">
          <div class="field-error" *ngIf="addErrors['email']">{{ addErrors['email'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">Phone Number <span class="field-hint">(required if no email)</span></label>
          <input type="text" class="form-control" placeholder="Phone number"
                [(ngModel)]="addForm.mobile" maxlength="10"
                (ngModelChange)="clearAddError('mobile')"
                [class.is-invalid]="addErrors['mobile']"
                autocomplete="new-password"
                name="mobile_solo">
          <div class="field-error" *ngIf="addErrors['mobile']">{{ addErrors['mobile'] }}</div>
        </div>

      </ng-container>

      <!-- ════ LAW FIRM fields ════ -->
      <ng-container *ngIf="addForm.category === 'entity'">

        <div class="form-group">
          <label class="form-label">Firm Name <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Enter firm name"
                [(ngModel)]="addForm.fullname"
                (ngModelChange)="clearAddError('fullname')"
                [class.is-invalid]="addErrors['fullname']"
                autocomplete="new-password"
                name="firmname_entity">
          <div class="field-error" *ngIf="addErrors['fullname']">{{ addErrors['fullname'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">Contact Person <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Contact person name"
                [(ngModel)]="addForm.contact_person"
                (ngModelChange)="clearAddError('contact_person')"
                [class.is-invalid]="addErrors['contact_person']"
                autocomplete="new-password"
                name="contact_entity">
          <div class="field-error" *ngIf="addErrors['contact_person']">{{ addErrors['contact_person'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">Email <span class="field-hint">(required if no phone)</span></label>
          <input type="email" class="form-control" placeholder="Email address"
                 [(ngModel)]="addForm.email"
                 (ngModelChange)="clearAddError('email')"
                 [class.is-invalid]="addErrors['email']"
                 autocomplete="new-password">
          <div class="field-error" *ngIf="addErrors['email']">{{ addErrors['email'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">Phone Number <span class="field-hint">(required if no email)</span></label>
          <input type="text" class="form-control" placeholder="Phone number"
                 [(ngModel)]="addForm.mobile" maxlength="10"
                 (ngModelChange)="clearAddError('mobile')"
                 [class.is-invalid]="addErrors['mobile']"
                 autocomplete="new-password">
          <div class="field-error" *ngIf="addErrors['mobile']">{{ addErrors['mobile'] }}</div>
        </div>

        <div class="form-group">
          <label class="form-label">No. of Licenses <span class="req">*</span></label>
          <select class="form-select" [(ngModel)]="addForm.users_allowed">
            <option *ngFor="let n of licenseOptions" [value]="n">{{ n }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Country <span class="req">*</span></label>
          <select class="form-select form-select--disabled" [(ngModel)]="addForm.country" disabled>
            <option value="India">India</option>
          </select>
        </div>

      </ng-container>

      <!-- Account Type -->
      <div class="form-group full-width radio-group">
        <label class="form-label">
          Account Type <span class="req">*</span>
        </label>

        <div class="radio-buttons-row">

          <label class="radio-option">
            <input type="radio" name="accountType" value="client" [(ngModel)]="addForm.account_type">
            <span class="radio-label">Client</span>
          </label>

          <label class="radio-option">
            <input type="radio" name="accountType" value="demo" [(ngModel)]="addForm.account_type">
            <span class="radio-label">Demo</span>
          </label>

          <label class="radio-option">
            <input type="radio" name="accountType" value="internal_test" [(ngModel)]="addForm.account_type">
            <span class="radio-label">Test Account</span>
          </label>

        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-cancel" (click)="closeAddModal()" [disabled]="isSubmitting">Cancel</button>
    <button class="btn btn-primary" (click)="submitAdd()" [disabled]="isSubmitting">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isSubmitting" class="bi bi-check-lg me-1"></i>
      {{ isSubmitting ? 'Adding...' : 'Add Lawyer' }}
    </button>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════
     EDIT MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showEditModal" (click)="closeEditModal()"></div>
<div class="modal-panel" *ngIf="showEditModal">
  <div class="modal-header">
    <h6 class="modal-title">
      <i class="bi bi-pencil-square me-2"></i>Edit Lawyer
    </h6>
    <button class="modal-close-btn" (click)="closeEditModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-grid">

      <div class="form-group full-width radio-group">
        <label class="form-label">Category <span class="req">*</span></label>
        <div class="radio-buttons-row">
          <label class="radio-option">
            <input type="radio" name="editCategory" value="solo"
                   [checked]="editForm.category === 'solo'"
                   (change)="onEditCategoryChange('solo')">
            <span class="radio-label">Solo Lawyer</span>
          </label>
          <label class="radio-option">
            <input type="radio" name="editCategory" value="entity"
                   [checked]="editForm.category === 'entity'"
                   (change)="onEditCategoryChange('entity')">
            <span class="radio-label">Law Firm</span>
          </label>
        </div>
      </div>

      <!-- ════ SOLO LAWYER fields ════ -->
      <ng-container *ngIf="editForm.category === 'solo'">

        <div class="form-group">
          <label class="form-label">Name <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Enter full name"
                 [(ngModel)]="editForm.fullname">
        </div>

        <div class="form-group">
          <label class="form-label">Country <span class="req">*</span></label>
          <select class="form-select form-select--disabled" [(ngModel)]="editForm.country" disabled>
            <option [value]="editForm.country">{{ editForm.country || 'India' }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Email <span class="field-hint">(required if no mobile)</span></label>
          <input type="email" class="form-control" placeholder="Email address"
                 [(ngModel)]="editForm.email">
        </div>

        <div class="form-group">
          <label class="form-label">Mobile <span class="field-hint">(required if no email)</span></label>
          <input type="text" class="form-control" placeholder="Mobile number"
                 [(ngModel)]="editForm.mobile">
        </div>

      </ng-container>

      <!-- ════ LAW FIRM fields ════ -->
      <ng-container *ngIf="editForm.category === 'entity'">

        <div class="form-group">
          <label class="form-label">Firm Name <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Enter firm name"
                 [(ngModel)]="editForm.fullname">
        </div>

        <div class="form-group">
          <label class="form-label">Country <span class="req">*</span></label>
          <select class="form-select form-select--disabled" [(ngModel)]="editForm.country" disabled>
            <option [value]="editForm.country">{{ editForm.country || 'India' }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Email <span class="field-hint">(required if no mobile)</span></label>
          <input type="email" class="form-control" placeholder="Email address" autocomplete="new-password"
                 [(ngModel)]="editForm.email">
        </div>

        <div class="form-group">
          <label class="form-label">Mobile <span class="field-hint">(required if no email)</span></label>
          <input type="text" class="form-control" placeholder="Mobile number"
                 [(ngModel)]="editForm.mobile">
        </div>

        <div class="form-group">
          <label class="form-label">No. of Licenses <span class="req">*</span></label>
          <select class="form-select" [(ngModel)]="editForm.licenses">
            <option *ngFor="let n of licenseOptions" [value]="n">{{ n }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Contact Person <span class="req">*</span></label>
          <input type="text" class="form-control" placeholder="Contact person name"
                 [(ngModel)]="editForm.contact_person">
        </div>

      </ng-container>

    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-cancel" (click)="closeEditModal()" [disabled]="isSubmitting">Cancel</button>
    <button class="btn btn-primary" (click)="submitEdit()" [disabled]="isSubmitting">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isSubmitting" class="bi bi-check-lg me-1"></i>
      {{ isSubmitting ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════
     DELETE MODAL
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showDeleteModal" (click)="closeDeleteModal()"></div>
<div class="modal-panel modal-sm" *ngIf="showDeleteModal">
  <div class="modal-header modal-header-danger">
    <h6 class="modal-title">Delete Lawyer</h6>
    <button class="modal-close-btn" (click)="closeDeleteModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="delete-confirm-body">
      <div class="delete-icon-wrap">
        <i class="bi bi-trash3 delete-icon"></i>
      </div>
      <p class="delete-msg">
        Are you sure you want to delete <strong>{{ selectedProfessional?.name }}</strong>?
      </p>
      <p class="delete-sub">This action cannot be undone.</p>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-cancel" (click)="closeDeleteModal()" [disabled]="isSubmitting">Cancel</button>
    <button class="btn btn-danger" (click)="confirmDelete()" [disabled]="isSubmitting">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isSubmitting" class="bi bi-trash me-1"></i>
      {{ isSubmitting ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════
     PLAN MODAL (Upgrade / Downgrade)
══════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="showPlanModal" (click)="closePlanModal()"></div>
<div class="modal-panel modal-plan" *ngIf="showPlanModal">

  <div class="modal-header"
       [class.modal-header-upgrade]="planModalMode === 'upgrade'"
       [class.modal-header-downgrade]="planModalMode === 'downgrade'">
    <h6 class="modal-title">
      <i class="bi me-2"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ planModalMode === 'upgrade' ? 'Upgrade Plan' : 'Downgrade Plan' }}
    </h6>
    <button class="modal-close-btn" (click)="closePlanModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Loading skeleton -->
  <div class="modal-body" *ngIf="planModalLoading">
    <div class="plan-skeleton">
      <div class="plan-sk-row"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row wide"></div>
      <div class="plan-sk-row"></div>
    </div>
  </div>

  <!-- Content -->
  <div class="modal-body" *ngIf="!planModalLoading && planModalData">

    <!-- Current plan banner -->
    <div class="current-plan-banner">
      <span class="cp-label">Current Plan</span>
      <span class="cp-name">{{ planModalData.current_plan?.name }}</span>
      <span class="cp-price">
        {{ planModalData.current_plan?.currency }}
        {{ planModalData.current_plan?.price | number:'1.0-0' }}/mo
      </span>
      <span class="cp-status"
            [class.cp-status--active]="planModalData.sub_status === 'active'"
            [class.cp-status--inactive]="planModalData.sub_status !== 'active'">
        {{ planModalData.sub_status | titlecase }}
      </span>
    </div>

    <!-- No options -->
    <div class="no-plan-options" *ngIf="planOptions.length === 0">
      <i class="bi bi-info-circle me-2"></i>
      No {{ planModalMode }} options available for this account.
    </div>

    <!-- Plan option cards -->
    <div class="plan-options-list" *ngIf="planOptions.length > 0">
      <label class="plan-option-card"
             *ngFor="let opt of planOptions"
             [class.plan-option-card--selected]="selectedPlanKey === opt.key"
             (click)="selectedPlanKey = opt.key">
        <input type="radio" name="planChoice" [value]="opt.key"
               [(ngModel)]="selectedPlanKey" style="display:none">
        <div class="poc-left">
          <div class="poc-radio">
            <i class="bi"
               [class.bi-record-circle-fill]="selectedPlanKey === opt.key"
               [class.bi-circle]="selectedPlanKey !== opt.key"></i>
          </div>
          <div class="poc-info">
            <span class="poc-name">{{ opt.name }}</span>
            <span class="poc-label">{{ opt.pricing?.label }}</span>
          </div>
        </div>
        <div class="poc-price">
          <span class="poc-amount">{{ opt.currency }} {{ opt.price | number:'1.0-0' }}</span>
          <span class="poc-period">/mo</span>
        </div>
      </label>
    </div>

    <!-- Pricing summary — UPGRADE -->
    <div class="pricing-summary"
         *ngIf="planModalMode === 'upgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Current plan price</span>
        <span>{{ pricing.currency }} {{ pricing.current_price | number:'1.2-2' }}/mo</span>
      </div>
      <div class="ps-row">
        <span>New plan price</span>
        <span>{{ pricing.currency }} {{ pricing.new_price | number:'1.2-2' }}/mo</span>
      </div>
      <div class="ps-row">
        <span>Remaining days in billing cycle</span>
        <span>{{ pricing.remaining_days }} days</span>
      </div>
      <div class="ps-row ps-highlight">
        <span>Prorated amount due now</span>
        <strong>{{ pricing.currency }} {{ pricing.adjustment_amount | number:'1.2-2' }}</strong>
      </div>
      <p class="ps-note">
        <i class="bi bi-envelope me-1"></i>
        A payment link will be sent to <strong>{{ planModalData.email }}</strong>
      </p>
    </div>

    <!-- Pricing summary — DOWNGRADE -->
    <div class="pricing-summary pricing-summary--downgrade"
         *ngIf="planModalMode === 'downgrade' && selectedPlanKey && getSelectedPlanPricing() as pricing">
      <div class="ps-row">
        <span>Monthly saving</span>
        <span class="ps-saving">{{ pricing.currency }} {{ pricing.saving | number:'1.2-2' }}/mo</span>
      </div>
      <div class="ps-row">
        <span>Effective date</span>
        <span>{{ pricing.effective_date }}</span>
      </div>
      <p class="ps-note ps-note--warning">
        <i class="bi bi-clock-history me-1"></i>
        Downgrade requires SuperUser approval before taking effect.
      </p>
    </div>

    <!-- Downgrade reason -->
    <div class="form-group downgrade-reason-wrap"
         *ngIf="planModalMode === 'downgrade' && planOptions.length > 0">
      <label class="form-label">
        Reason for Downgrade <span class="req">*</span>
      </label>
      <textarea class="form-control" rows="3"
                placeholder="e.g. Client not using advanced features."
                [(ngModel)]="downgradeReason"
                (ngModelChange)="downgradeReasonError = ''"
                [class.is-invalid]="downgradeReasonError">
      </textarea>
      <div class="field-error" *ngIf="downgradeReasonError">{{ downgradeReasonError }}</div>
    </div>

  </div>

  <div class="modal-footer" *ngIf="!planModalLoading">
    <button class="btn btn-cancel" (click)="closePlanModal()" [disabled]="isPlanSubmitting">
      Cancel
    </button>
    <button class="btn"
            [class.btn-upgrade]="planModalMode === 'upgrade'"
            [class.btn-downgrade]="planModalMode === 'downgrade'"
            (click)="submitPlanChange()"
            [disabled]="isPlanSubmitting || planOptions.length === 0 || !selectedPlanKey">
      <span *ngIf="isPlanSubmitting" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!isPlanSubmitting" class="bi me-1"
         [class.bi-arrow-up-circle]="planModalMode === 'upgrade'"
         [class.bi-arrow-down-circle]="planModalMode === 'downgrade'"></i>
      {{ isPlanSubmitting
          ? 'Processing...'
          : (planModalMode === 'upgrade' ? 'Confirm Upgrade' : 'Submit Downgrade') }}
    </button>
  </div>

</div>

<!-- ══════════════════════════════════════════════════════════
     Account type MODAL
══════════════════════════════════════════════════════════ -->
<div class="status-modal-overlay" *ngIf="showAccountTypeModal">
  <div class="status-modal">

    <h3 class="status-title">Update Account Type</h3>

    <div class="status-options">

      <button
        class="status-btn"
        [class.active]="selectedAccountType === 'client'"
        (click)="selectedAccountType = 'client'">
        Client
      </button>

      <button
        class="status-btn"
        [class.active]="selectedAccountType === 'demo'"
        (click)="selectedAccountType = 'demo'">
        Demo
      </button>

      <button
        class="status-btn"
        [class.active]="selectedAccountType === 'internal_test'"
        (click)="selectedAccountType = 'internal_test'">
        Test Account
      </button>

    </div>

    <div class="status-actions">
      <button class="btn-cancel" (click)="closeAccountTypeModal()">
        Cancel
      </button>

      <button class="btn-update" (click)="updateAccountType()">
        Update
      </button>
    </div>

  </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff"
             type="ball-clip-rotate" [fullScreen]="true">
</ngx-spinner>